'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Utils = require('../Utils2');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;

var BoxFooter = function (_React$Component) {
    (0, _inherits3.default)(BoxFooter, _React$Component);

    function BoxFooter() {
        (0, _classCallCheck3.default)(this, BoxFooter);
        return (0, _possibleConstructorReturn3.default)(this, (BoxFooter.__proto__ || (0, _getPrototypeOf2.default)(BoxFooter)).apply(this, arguments));
    }

    (0, _createClass3.default)(BoxFooter, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                children = _props.children,
                otherProps = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);


            className = (0, _classnames2.default)('box-footer', className);

            return _react2.default.createElement(
                'div',
                (0, _extends3.default)({ className: className }, otherProps),
                children
            );
        }
    }]);
    return BoxFooter;
}(_react2.default.Component);

BoxFooter.PropTypes = {
    className: _react2.default.PropTypes.string,
    children: _Utils.COMPONENT_CHILDREN
};
exports.default = BoxFooter;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvYm94L0Zvb3Rlci5qc3giXSwibmFtZXMiOlsiQm94Rm9vdGVyIiwicHJvcHMiLCJjbGFzc05hbWUiLCJjaGlsZHJlbiIsIm90aGVyUHJvcHMiLCJSZWFjdCIsIkNvbXBvbmVudCIsIlByb3BUeXBlcyIsInN0cmluZyIsIkNPTVBPTkVOVF9DSElMRFJFTiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBOzs7O0FBR0E7Ozs7QUFFQTs7OztBQUpBOztJQU1xQkEsUzs7Ozs7Ozs7OztpQ0FNUjtBQUFBLHlCQUNzQyxLQUFLQyxLQUQzQztBQUFBLGdCQUNBQyxTQURBLFVBQ0FBLFNBREE7QUFBQSxnQkFDV0MsUUFEWCxVQUNXQSxRQURYO0FBQUEsZ0JBQ3dCQyxVQUR4Qjs7O0FBR0xGLHdCQUFZLDBCQUFXLFlBQVgsRUFBeUJBLFNBQXpCLENBQVo7O0FBRUEsbUJBQ0k7QUFBQTtBQUFBLHlDQUFLLFdBQVdBLFNBQWhCLElBQStCRSxVQUEvQjtBQUNLRDtBQURMLGFBREo7QUFLSDs7O0VBaEJrQ0UsZ0JBQU1DLFM7O0FBQXhCTixTLENBQ1ZPLFMsR0FBWTtBQUNmTCxlQUFXRyxnQkFBTUUsU0FBTixDQUFnQkMsTUFEWjtBQUVmTCxjQUFVTTtBQUZLLEM7a0JBREZULFMiLCJmaWxlIjoiRm9vdGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbjtcblxuaW1wb3J0IGNsYXNzTmFtZXMgZnJvbSAnY2xhc3NuYW1lcyc7XG5cbmltcG9ydCB7Q09NUE9ORU5UX0NISUxEUkVOfSBmcm9tICcuLi9VdGlsczInO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBCb3hGb290ZXIgZXh0ZW5kcyBSZWFjdC5Db21wb25lbnQge1xuICAgIHN0YXRpYyBQcm9wVHlwZXMgPSB7XG4gICAgICAgIGNsYXNzTmFtZTogUmVhY3QuUHJvcFR5cGVzLnN0cmluZyxcbiAgICAgICAgY2hpbGRyZW46IENPTVBPTkVOVF9DSElMRFJFTlxuICAgIH07XG5cbiAgICByZW5kZXIoKSB7XG4gICAgICAgIGxldCB7Y2xhc3NOYW1lLCBjaGlsZHJlbiwgLi4ub3RoZXJQcm9wc30gPSB0aGlzLnByb3BzO1xuXG4gICAgICAgIGNsYXNzTmFtZSA9IGNsYXNzTmFtZXMoJ2JveC1mb290ZXInLCBjbGFzc05hbWUpO1xuXG4gICAgICAgIHJldHVybiAoXG4gICAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT17Y2xhc3NOYW1lfSB7Li4ub3RoZXJQcm9wc30+XG4gICAgICAgICAgICAgICAge2NoaWxkcmVufVxuICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICk7XG4gICAgfVxufVxuIl19